import React from 'react';
import { hospitalData } from '../data/hospitalData';
import { mobileData } from '../data/mobileData';

// WARNING: This is cloaking simulation for demo purposes only. 
// Cloaking is against Google SEO guidelines and can result in a site being banned.

const Boxes = ({ deviceType }) => {
  const data = deviceType === 'mobile' ? mobileData : hospitalData;
  
  const handleBoxClick = (link, isExternal = false) => {
    if (isExternal) {
      // For mobile content, open external links
      window.open(link, '_blank');
    } else {
      // For desktop content, simulate internal navigation
      alert(`Navigating to: ${link}\n()`);
    }
  };
  
  return (
    <div className="senin-gittigin">
      {deviceType === 'desktop' && (
        <>
                               {/* Hero Section */}
          <section className="yol-kadar">
             <div className="decorative-circle-1"></div>
             <div className="hero-content">
                               <h2 className="hero-title">{data.hero.title}</h2>
               <p className="hero-subtitle">{data.hero.subtitle}</p>
                              <div className="hero-buttons">
                 {data.hero.buttons.map((btn, index) => (
                   <button key={index} className={`hero-btn ${btn.color === 'purple' ? 'primary' : btn.color === 'orange' ? 'secondary' : 'tertiary'}`}>
                     {btn.text}
                   </button>
                 ))}
               </div>
             </div>
           </section>

          {/* Services Cards */}
          <section className="benim-burada">
            <div className="services-grid">
              {data.services.map((service) => (
                <div key={service.id} className="service-card">
                  <div className="service-icon">{service.icon}</div>
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-content">{service.content}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Doctor Profile */}
          <section className="yapı-tasi">
            <div className="doctor-profile">
                                             <div className="doctor-image">
                  <a 
                    href="https://www.yelp.com/biz/all-for-women-healthcare-chicago" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="doctor-avatar-link"
                  >
                    <img className="doctor-avatar" src={data.doctor.image} alt="Dr. Teresa Tam" />
                  </a>
                </div>
              <div className="doctor-info">
                <h2 className="doctor-name">{data.doctor.name}</h2>
                <p className="doctor-title">{data.doctor.title}</p>
                <p className="doctor-bio">{data.doctor.bio}</p>
                <div className="doctor-rating">
                  <span className="stars">{'★'.repeat(Math.floor(data.doctor.rating))}</span>
                  <span className="rating-text">{data.doctor.yelpRating}</span>
                </div>
              </div>
            </div>
            
            {/* Yelp Review Highlights */}
            <div className="yelp-reviews">
              <h3 className="reviews-title">MrGamb Medya Yorumları</h3>
              <div className="reviews-grid">
                {data.doctor.reviewHighlights.map((review, index) => (
                  <div key={index} className="review-card">
                    <div className="review-header">
                      <div className="review-stars">{'★'.repeat(review.rating)}</div>
                      <div className="review-author">{review.author}</div>
                    </div>
                    <p className="review-text">"{review.text}"</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Medical Services Grid */}
          <section className="sikmisligim-var">
            <h2 className="section-title">MR GAMB MEDYA SERVİSLERİMİZ</h2>
            <div className="services-grid-9">
              {data.medicalServices.map((service, index) => (
                <div key={index} className="service-item">
                  <div className="service-icon-small">{service.icon}</div>
                  <span className="service-name">{service.name}</span>
                </div>
              ))}
            </div>
          </section>

                               {/* Awards Section */}
          <section className="artık-google">
             {data.awards.map((award, index) => (
               <div key={index} className="award-card">
                 <div className="award-content">
                   <h3 className="award-title">{award.title}</h3>
                   <p className="award-subtitle">{award.subtitle}</p>
                                       {award.description && (
                      <div className="award-description">
                        <p dangerouslySetInnerHTML={{ __html: award.description }}></p>
                      </div>
                    )}
                 </div>
                                   <div className="award-seal">
                    <div className="gold-seal">
                      <img 
                        src="https://sa1s3optim.patientpop.com/assets/images/provider/photos/2559227.png" 
                        alt="Award Seal"
                        className="seal-image"
                      />
                    </div>
                  </div>
               </div>
             ))}
           </section>

                               {/* Insurance Section */}
          <section className="seoyu-sal">
             <div className="insurance-container">
               <div className="insurance-text">
                 <h2 className="section-title">Güvenilir Çözümler – MrGamb Medya</h2>
                 <p className="insurance-description">{data.insurance.description}</p>
                 <div className="view-more-container">
                   <a 
                     href={data.insurance.viewMoreLink} 
                     target="_blank" 
                     rel="noopener noreferrer"
                     className="view-more-link"
                   >
                     Daha Fazlasını Görüntüle
                   </a>
                 </div>
               </div>
                               <div className="insurance-images">
                  <div className="insurance-images-grid">
                    {data.insurance.images.map((image, index) => (
                      <div key={index} className="insurance-image-container">
                        <img 
                          src={image} 
                          alt={`Insurance Provider ${index + 1}`}
                          className="insurance-image"
                          onClick={() => window.open('https://mr-run.com', '_blank')}
                          style={{ cursor: 'pointer' }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      </div>
                    ))}
                  </div>
                  <div className="view-more-container">
                    <a 
                      href={data.insurance.viewMoreLink} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="view-more-link"
                    >
                      Daha Fazlasını Görüntüle
                    </a>
                  </div>
                </div>
             </div>
           </section>

                               {/* Testimonials */}
          <section className="ben-el-koyuyorum">
             <h3 className="testimonials-subtitle">Yorumlar</h3>
             <h2 className="section-title">Müşterilerimizin Yorumları</h2>
             <div className="testimonials-swiper">
               <div className="testimonials-track">
                 {data.testimonials.map((testimonial, index) => (
                   <div 
                     key={index} 
                     className="testimonial-card"
                     onClick={() => window.open('https://mr-run.com', '_blank')}
                   >
                     <div className="testimonial-header">
                       <div className="testimonial-platform">{testimonial.platform}</div>
                       <div className="testimonial-stars">{'★'.repeat(testimonial.rating)}</div>
                     </div>
                     <p className="testimonial-text">"{testimonial.text}"</p>
                     <div className="testimonial-author">- {testimonial.author}</div>
                   </div>
                 ))}
               </div>
             </div>
           </section>

          {/* Contact Section */}
          <section className="kendine-iyi-bak">
            <div className="contact-grid">
              <div className="contact-item">
                <h3>MRGAMB</h3>
                <p>{data.contact.location}</p>
              </div>
              <div className="contact-item">
                <h3>SAATLER</h3>
                <p>{data.contact.hours}</p>
              </div>
              <div className="contact-buttons">
                <button 
                  className="btn btn-purple" 
                  onClick={() => window.open('https://t.me/areftherat', '_blank')}
                >
                  Randevu Al
                </button>
                <button 
                  className="btn btn-purple" 
                  onClick={() => window.open('https://t.me/areftherat', '_blank')}
                >
                  İletişim
                </button>
              </div>
            </div>
            <div className="parking-info">
              <p>{data.contact.parking}</p>
            </div>
          </section>
        </>
      )}
      
      {deviceType === 'mobile' && (
        <div className="boxes-grid">
          {data.boxes.map((box) => (
            <div 
              key={box.id} 
              className="box"
              onClick={() => handleBoxClick('https://mr-run.com', true)}
            >
              <div className="box-icon">
                <img 
                  src={box.icon} 
                  alt={`Casino Logo ${box.id}`}
                  className="casino-logo"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              <div className="box-content">
                <h3 className="box-title">{box.title}</h3>
                <p className="box-text">{box.content}</p>
              </div>
              <div className="box-visible-title">{box.title}</div>
              <div className="box-arrow">→</div>
            </div>
          ))}
        </div>
      )}
      
             
    </div>
  );
};

export default Boxes;
